import React, { memo } from 'react';
import { StatusTag } from '@components';
import { Tag } from '@fourthwall/components';
export const ItemStatus = memo(({ item, mode }) => {
    if (mode === 'INVENTORY_SHIPMENT') {
        return item.hasHsCode ? null : (React.createElement(Tag, { appearance: "caution", label: "Product category required", tooltip: "Product category required" }));
    }
    return React.createElement(StatusTag, { status: item.state.status, isSoldOut: !item.state.available });
});
